export const DUTY_ROSTER_TOUR_ID = 'duty-roster'

export const DUTY_ROSTER_ONBOARDING_STEPS = [
  {
    title: 'A escala do mês',
    body: 'Aqui você monta quem fica com o paciente. Escolhe a pessoa, marca a equipe e o mês se preenche.',
  },
  {
    target: '[data-onboarding="roster-patient"]',
    title: 'O paciente da escala',
    body: 'A foto abre a lista. A escala é de um paciente por vez. Troca o nome e o calendário acompanha.',
  },
  {
    target: '[data-onboarding="roster-team"]',
    title: 'Quem pode entrar',
    body: 'O círculo tracejado marca a equipe da geração. Arrasta o avatar para o dia, ou clica na pessoa e depois no turno vazio.',
  },
  {
    target: '[data-onboarding="roster-access"]',
    title: 'Só quem acessa',
    body: 'O scan deixa na lista apenas quem pode abrir o prontuário deste paciente. Se o prontuário é aberto para todo mundo, a lista continua completa.',
  },
  {
    target: '[data-onboarding="roster-group"]',
    title: 'Um grupo só',
    body: 'O escudo escolhe um grupo de acesso. Dá para usar junto com o scan: grupo e acesso ao mesmo tempo.',
  },
  {
    target: '[data-onboarding="roster-calendar"]',
    title: 'O mês',
    body: 'Cada dia tem o diurno e o noturno. O nome e a foto de quem ficou aparecem direto no dia. O relógio muda a hora de início.',
  },
  {
    target: '[data-onboarding="roster-generate"]',
    title: 'Gerar, salvar, limpar',
    body: 'Gerar completa os lugares vazios e respeita o que você arrastou. Salvar guarda a escala. Limpar esvazia o mês deste paciente.',
  },
  {
    target: '[data-onboarding="roster-saved"]',
    title: 'Escalas salvas',
    body: 'Esta aba guarda o que já foi salvo. Abre de novo e o calendário volta naquele paciente e naquele mês.',
  },
]
